var _path, _rect, _rect2, _rect3, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLove13017871(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    "data-name": "Layer 3",
    id: "Layer_3",
    viewBox: "0 0 64 64",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M47.009,23.405l4.7-4.7a1,1,0,0,0,.188-1.154l-3-6A1,1,0,0,0,48,11H38a1,1,0,0,0-.9.553l-3,6a1,1,0,0,0,.188,1.154L39,23.413a19.8,19.8,0,0,0-7,2.9,20,20,0,1,0,0,33.374A19.994,19.994,0,1,0,47.009,23.405ZM49.382,17H45.135l2.654-3.185ZM43,16.438,40.135,13h5.73Zm-4.789-2.623L40.865,17H36.618ZM37.414,19H48.586l-4.077,4.076c-.5-.037-1-.076-1.509-.076s-1.021.02-1.528.058ZM21,61a18.03,18.03,0,1,1,15.089-8.207,12.073,12.073,0,0,1-2.9-2.911,14.008,14.008,0,1,0-5.805,5.575,20.165,20.165,0,0,0,2.9,2.968A17.888,17.888,0,0,1,21,61ZM37.8,32.19a12.006,12.006,0,1,1,.015,21.616A19.9,19.9,0,0,0,37.8,32.19ZM32,38.213A11.958,11.958,0,0,1,32,47.787,11.958,11.958,0,0,1,32,38.213Zm-5.813-6.019A19.9,19.9,0,0,0,26.2,53.81a12.006,12.006,0,1,1-.015-21.616ZM43,61A17.984,17.984,0,0,1,27.911,33.207a12.073,12.073,0,0,1,2.9,2.911,14.008,14.008,0,1,0,5.8-5.575,20.165,20.165,0,0,0-2.9-2.968A18,18,0,1,1,43,61Z"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    height: 6,
    width: 2,
    x: 42,
    y: 1
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    height: 2,
    transform: "translate(10.316 35.906) rotate(-45)",
    width: 7.071,
    x: 44.964,
    y: 4.5
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    height: 7.071,
    transform: "translate(7.094 28.127) rotate(-45)",
    width: 2,
    x: 36.5,
    y: 1.964
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M5.553,17.9l1.317.658A3.832,3.832,0,0,1,9,22a1,1,0,0,0,2,0,3.832,3.832,0,0,1,2.129-3.446l1.318-.658a1,1,0,0,0,0-1.79l-1.317-.658A3.832,3.832,0,0,1,11,12a1,1,0,0,0-2,0,3.832,3.832,0,0,1-2.13,3.447l-1.317.658a1,1,0,0,0,0,1.79ZM10,15.283A5.835,5.835,0,0,0,11.808,17,5.835,5.835,0,0,0,10,18.717,5.835,5.835,0,0,0,8.192,17,5.835,5.835,0,0,0,10,15.283Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M20.553,7.9l1.317.658A3.832,3.832,0,0,1,24,12a1,1,0,0,0,2,0,3.832,3.832,0,0,1,2.129-3.446L29.447,7.9a1,1,0,0,0,0-1.79L28.13,5.447A3.832,3.832,0,0,1,26,2a1,1,0,0,0-2,0,3.832,3.832,0,0,1-2.13,3.447l-1.317.658a1,1,0,0,0,0,1.79ZM25,5.283A5.835,5.835,0,0,0,26.808,7,5.835,5.835,0,0,0,25,8.717,5.835,5.835,0,0,0,23.192,7,5.835,5.835,0,0,0,25,5.283Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLove13017871);
export default __webpack_public_path__ + "static/media/love_13017871.b3abad628e68fd687ab31fef0f217757.svg";
export { ForwardRef as ReactComponent };